<div class="tab-pane show active fade details-view-results" role="tabpanel">
  <div class="details-view-results-head">
    <app-button text="Settings" variant="info" size="sm" />
    <app-button text="Amend Dosage" variant="secondary" size="sm" />
  </div>
</div>
